<template lang="pug">
section.challenges
  .challenges__section
    .challenges__title(v-html="challengeGroups.group1.label")
    .challenges__wrap
      ChallengeCard.card--gray(v-for="(el, i) of arrayOne" :key="i" :step="i + 1" :data="getChallengePayload(el)")
  .challenges__section
    .challenges__title(v-html="challengeGroups.group2.label")
    .challenges__wrap
      ChallengeCard.card--yellow(v-for="(el, i) of arrayTwo" :key="i" :step="i + 1" :data="getChallengePayload(el)")
  .challenges__section
    .challenges__title(v-html="challengeGroups.group3.label")
    .challenges__wrap
      ChallengeCard.card--red(v-for="(el, i) of arrayThree" :key="i" :step="i + 1" :data="getChallengePayload(el)")
</template>

<script>
import ChallengeCard from "./ChallengeCard";

export default {
  name: "Challenges",
  components: {
    ChallengeCard,
  },
  props: {
    challenges: {
      type: Object,
      default: null,
    },
    challengeGroups: {
      type: Object,
      default: null,
    },
  },
  computed: {
    arrayOne() {
      return this.challengeGroups.group1?.quests ?? [];
    },
    arrayTwo() {
      return this.challengeGroups.group2?.quests ?? [];
    },
    arrayThree() {
      return this.challengeGroups.group3?.quests ?? [];
    },
  },
  methods: {
    getChallengePayload(challenge) {
      const serverObject = this.challenges[challenge.key]

      if (serverObject) {
        return {
          label: challenge.label,
          ...serverObject,
        };
      }

      return null;
    },
  },
};
</script>
